module.exports = __webpack_public_path__ + "img/29-r.6fc107c6.png";